/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ViewSchedule/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CalendarUnscheduledIcon from 'DesignSystem/Svgs/Tysiav2CalendarUnscheduledIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ViewSchedule({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/ActionsPopover/ViewSchedule"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="ViewSchedule.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CalendarUnscheduledIcon
  viewPath={`${viewPath}/Tysiav2CalendarUnscheduledIcon`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="View Schedule"
 color={dtColorsNeutral900}
 marginLeft={dtSpaceXs}
/>
</div>
{children}
</React.Fragment>)
}